import PropTypes from 'prop-types';
import {useState} from 'react';
import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {Button, Confirm} from 'semantic-ui-react';

import httpClient from 'httpClient';
import {addSuccessMessage} from 'state/actions';

import styles from './DeleteShortUrlModal.module.scss';

const DeleteShortUrlModal = ({url, id, targetUrl}) => {
  const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();

  return (
    <Confirm
      className={styles.DeleteShortUrlModal}
      content={
        <div className="content">
          You are going to delete the short URL{' '}
          <a href={url} target="_blank" rel="noreferrer">
            {url}
          </a>{' '}
          which points to{' '}
          <a href={targetUrl} target="_blank" rel="noreferrer">
            {targetUrl}
          </a>
          . Do you want to proceed?
        </div>
      }
      open={openDeleteConfirmation}
      onCancel={() => setOpenDeleteConfirmation(false)}
      onConfirm={async () => {
        const redirectorHost = new URL(url).host;
        await httpClient.delete(`/api/web-redirector/${redirectorHost}/short-urls/${id}`);
        dispatch(addSuccessMessage('The short URL was removed successfully'));
        setOpenDeleteConfirmation(false);
        history.push('/short-urls');
      }}
      confirmButton={{
        negative: true,
        content: 'Delete',
      }}
      trigger={
        <Button
          className={styles.DeleteButton}
          color="red"
          icon="trash"
          onClick={() => {
            setOpenDeleteConfirmation(true);
          }}
          content="Delete"
        />
      }
    />
  );
};

DeleteShortUrlModal.propTypes = {
  url: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  targetUrl: PropTypes.string.isRequired,
};

export default DeleteShortUrlModal;
